import tokens from './semanticColors.json'

type SemanticColorGroup = Record<string, string>
type SemanticColors = Record<'bg' | 'border' | 'text', SemanticColorGroup>

type StripPrefix<K extends string, P extends string> = K extends `${P}-${infer Rest}` ? Rest : never

type GroupedTokens<T extends Record<string, string>> = {
    bg: { [K in Extract<keyof T, string> as StripPrefix<K, 'bg'>]: string }
    border: { [K in Extract<keyof T, string> as StripPrefix<K, 'border'>]: string }
    text: { [K in Extract<keyof T, string> as StripPrefix<K, 'text'>]: string }
}

// Groups flat token keys (e.g. `bg-brand-rest`) by their prefix so hex values can
// be referenced in style props and other non-className contexts, mirroring the
// grouping used by the Tailwind config.
function groupTokens<T extends Record<string, string>>(input: T): GroupedTokens<T> {
    const grouped: SemanticColors = { bg: {}, border: {}, text: {} }

    for (const [key, value] of Object.entries(input)) {
        const [group, ...rest] = key.split('-')
        if (group === 'bg' || group === 'border' || group === 'text') {
            grouped[group][rest.join('-')] = value
        }
    }

    return grouped as GroupedTokens<T>
}

export const semanticColors = groupTokens(tokens['mode-1'])

export type SemanticColorName = keyof (typeof semanticColors)['bg']
